module.exports = __webpack_public_path__ + "img/toggle.98455dba.svg";